/* eslint-disable */
// /src/pages/StoreDetailPage.jsx

import React, { useEffect, useMemo, useState, useRef } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import PageTopBar from "../components/PageTopBar";
import { fetchProductById } from "../services/storePublicService";
import { createStoreOrder, updateStoreOrder } from "../services/storeOrderService";
import { useDriverStatusContext } from "../context/DriverStatusContext";
import {
    getDefaultOrderProfile,
    saveDefaultOrderProfile,
    clearDefaultOrderProfile,
} from "../services/storeProfileService";
import { addStoreCartItem } from "../services/storeCartService";

// ✅ 포인트(사용/잔액 조회 + 차감)
import { fetchMemberPointsBalance, applyPointsChange } from "../services/pointsService";

// ✅ memberDocId 조회용 (Franchise와 동일 패턴)
import { db } from "../services/firebase";
import { collection, getDocs, limit, query, where } from "firebase/firestore";

const Wrap = styled.div`
  min-height: 100vh;
  background: linear-gradient(180deg, #d7e8ff 0%, #eaf3ff 100%);
  display: flex;
  flex-direction: column;
`;

const Sheet = styled.div`
  background: #f7faff;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
`;

const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  padding-bottom: 110px; /* ✅ 하단 고정 바 영역 확보 */
  max-width: 760px;
  width: 100%;
  margin: 0 auto;
`;

/* ✅ 하단 고정 주문 바 */
const FixedOrderButton = styled.button`
  flex: 1;
  appearance: none;
  border: 0;
  border-radius: 999px;
  height: 40px;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  background: #2563eb;
  color: #fff;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  &:active {
    transform: translateY(1px);
  }
`;

const FixedCartButton = styled.button`
  flex: 1;
  appearance: none;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  height: 40px;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background: #ffffff;
  color: #111827;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  &:active {
    transform: translateY(1px);
  }
`;

const FixedOrderBarOuter = styled.div`
  position: fixed;
  inset-inline: 0;
  bottom: 0;
  z-index: 120;
  display: flex;
  justify-content: center;
  pointer-events: none;
`;

const FixedOrderBarInner = styled.div`
  pointer-events: auto;
  width: 100%;
  max-width: 760px;
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
  background: rgba(247, 250, 255, 0.98);
  backdrop-filter: blur(8px);
  border-top: 1px solid #e5eaf5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const FixedOrderSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  .label {
    font-size: 11px;
    color: #94a3b8;
  }
  .price {
    font-size: 16px;
    font-weight: 800;
    color: #0f172a;
  }
`;

/* 이미지 Hero 영역 */
const Hero = styled.div`
  position: relative;
  width: 100%;
  height: 260px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  overflow: hidden;
  touch-action: pan-y;
  user-select: none;
`;

const HeroTrack = styled.div`
  display: flex;
  height: 100%;
  will-change: transform;
  transform: translateX(${(p) => `-${p.$index * 100}%`});
  transition: ${(p) => (p.$anim ? "transform .35s ease" : "none")};
`;

const HeroSlide = styled.div`
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
`;

const Dots = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  margin-top: 8px;
`;
const Dot = styled.button`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 0;
  cursor: pointer;
  background: ${(p) => (p.$on ? "#2563EB" : "rgba(0,0,0,.22)")};
`;

/* 섹션 라벨/구분선/본문 */
const Label = styled.h3`
  margin: 14px 0 2px;
  font-size: 18px;
  color: #0f172a;
  font-weight: 800;
`;
const Divider = styled.hr`
  height: 1px;
  border: 0;
  background: #e5eaf5;
  margin: 0 0 10px;
`;
const Title = styled.h2`
  margin: 0 0 6px;
  font-size: 20px;
  color: #0f172a;
  font-weight: 700;
`;
const Price = styled.div`
  font-size: 18px;
  color: #0f172a;
  font-weight: 400;
  margin-bottom: 6px;
`;
const Subtle = styled.div`
  color: #64748b;
  font-size: 13px;
  font-weight: 400;
`;
const Text = styled.div`
  color: #0f172a;
  font-size: 14px;
  line-height: 1.55;
  white-space: pre-wrap;
  font-weight: 400;
`;

/* 옵션 칩 */
const OptionChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const OptionChip = styled.button`
  border-radius: 999px;
  border: 1px solid ${(p) => (p.$active ? "#2563EB" : "#E5E7EB")};
  background: ${(p) => (p.$active ? "#EFF6FF" : "#FFFFFF")};
  padding: 5px 10px;
  font-size: 12px;
  cursor: pointer;
  color: ${(p) => (p.$active ? "#1D4ED8" : "#374151")};
`;

/* 상세 이미지 리스트 */
const DetailImages = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    background: #fff;
  }
`;

/* ✅ 계좌(상품 bankAccount만 표시) */
const BankBox = styled.div`
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  .row {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
  }
  .copy {
    border: 1px solid #d1d5db;
    background: #fff;
    border-radius: 8px;
    padding: 6px 10px;
    font-size: 12px;
    cursor: pointer;
  }
`;

/* 주문 바텀시트 */
const OrderOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.4);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 80;
`;

const OrderSheet = styled.div`
  width: 100%;
  max-width: 760px;
  max-height: 90vh;
  background: #ffffff;
  border-radius: 18px 18px 0 0;
  box-shadow: 0 -16px 40px rgba(15, 23, 42, 0.4);
  display: flex;
  flex-direction: column;
  padding: 10px 16px 8px;
`;

/* 시트 내 스크롤 영역 */
const OrderContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-top: 4px;
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  -webkit-overflow-scrolling: touch;
`;

const SheetHandle = styled.div`
  width: 44px;
  height: 4px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.6);
  align-self: center;
  margin-bottom: 6px;
`;

const SheetTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
`;

const SheetSection = styled.div`
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  padding: 10px 10px 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SectionHeader = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
`;

const FieldRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const FieldLabel = styled.label`
  font-size: 12px;
  color: #6b7280;
`;

const Input = styled.input`
  flex: 1;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  padding: 7px 9px;
  font-size: 13px;
`;

const Textarea = styled.textarea`
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  padding: 7px 9px;
  font-size: 13px;
  resize: vertical;
  min-height: 60px;
`;

const QtyRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const QtyButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 999px;
  border: 1px solid #d1d5db;
  background: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
`;

const QtyValue = styled.span`
  min-width: 20px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
`;

const SheetBottom = styled.div`
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const SheetSummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #4b5563;
`;

const SheetTotal = styled.div`
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
`;

const SheetButtons = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 4px;
`;

const SubmitBtn = styled.button`
  flex: 2;
  border-radius: 999px;
  border: 0;
  background: #2563eb;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  padding: 9px 0;
`;

const CartLinkButton = styled.button`
  flex: 1;
  border-radius: 999px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 9px 0;
  color: #374151;
`;

const AddressRow = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

const AddressSearchButton = styled.button`
  border-radius: 8px;
  border: 1px solid #d1d5db;
  background: #e5edff;
  padding: 0 10px;
  height: 32px;
  font-size: 12px;
  font-weight: 600;
  color: #1d4ed8;
  white-space: nowrap;
  cursor: pointer;
`;

const SectionHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

/* Daum 우편번호 레이어 모달 (앱에서 사용) */
const PostcodeOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 90;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PostcodePanel = styled.div`
  width: 100%;
  max-width: 480px;
  height: 70vh;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.4);
  display: flex;
  flex-direction: column;
  padding: 8px 10px 10px;
`;

const PostcodeHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 4px 2px 8px;
  border-bottom: 1px solid #e5e7eb;
`;

const PostcodeTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
`;

const PostcodeCloseButton = styled.button`
  border: 0;
  background: transparent;
  padding: 4px 6px;
  border-radius: 999px;
  cursor: pointer;
  font-size: 13px;
  color: #6b7280;
  &:hover {
    background: #f3f4f6;
  }
`;

const PostcodeBody = styled.div`
  flex: 1;
  margin-top: 6px;
  border-radius: 12px;
  overflow: hidden;
  background: #f9fafb;
`;

const KRW = (n = 0) => Number(n || 0).toLocaleString("ko-KR") + "원";

const POSTCODE_SCRIPT_URL =
    "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";

const loadPostcodeScript = () =>
    new Promise((resolve, reject) => {
        if (typeof window === "undefined") {
            reject(new Error("window is undefined"));
            return;
        }
        if (window.daum && window.daum.Postcode) {
            resolve();
            return;
        }
        const exists = document.querySelector(`script[src="${POSTCODE_SCRIPT_URL}"]`);
        if (exists) {
            exists.addEventListener("load", () => resolve());
            exists.addEventListener("error", reject);
            return;
        }
        const script = document.createElement("script");
        script.src = POSTCODE_SCRIPT_URL;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = reject;
        document.body.appendChild(script);
    });

function safeInt(v) {
    const n = Number(String(v ?? "").replace(/[^\d]/g, ""));
    return Number.isFinite(n) ? n : 0;
}

function safeStr(v) {
    return String(v || "").trim();
}

export default function StoreDetailPage() {
    const { id } = useParams();
    const nav = useNavigate();
    const { phoneE164 } = useDriverStatusContext();

    const [prod, setProd] = useState(null);
    const [idx, setIdx] = useState(0);

    const [orderOpen, setOrderOpen] = useState(false);
    const [qty, setQty] = useState(1);
    const [selectedOptions, setSelectedOptions] = useState({});

    const [ordererName, setOrdererName] = useState("");
    const [ordererPhone, setOrdererPhone] = useState("");
    const [ordererEmail, setOrdererEmail] = useState("");
    const [ordererZip, setOrdererZip] = useState("");
    const [ordererAddr1, setOrdererAddr1] = useState("");
    const [ordererAddr2, setOrdererAddr2] = useState("");

    const [recvName, setRecvName] = useState("");
    const [recvPhone, setRecvPhone] = useState("");
    const [recvZip, setRecvZip] = useState("");
    const [recvAddr1, setRecvAddr1] = useState("");
    const [recvAddr2, setRecvAddr2] = useState("");
    const [recvMemo, setRecvMemo] = useState("");
    const [sameAsOrderer, setSameAsOrderer] = useState(false);

    const [profileLoading, setProfileLoading] = useState(true);
    const [hasDefaultProfile, setHasDefaultProfile] = useState(false);
    const [saveAsDefault, setSaveAsDefault] = useState(false);

    const [postcodeVisible, setPostcodeVisible] = useState(false);
    const postcodeTargetRef = useRef(null);
    const postcodeContainerRef = useRef(null);

    const touchStartXRef = useRef(null);
    const touchDeltaXRef = useRef(0);
    const [heroAnim, setHeroAnim] = useState(true);

    // ✅ 포인트(Franchise 방식: memberDocId 필요)
    const [pointsLoading, setPointsLoading] = useState(false);
    const [memberDocId, setMemberDocId] = useState("");
    const [pointsBalance, setPointsBalance] = useState(0);
    const [usePoints, setUsePoints] = useState(0);

    const handlePostcodeComplete = (data, target) => {
        const addr = data.roadAddress || data.jibunAddress || "";
        const zonecode = data.zonecode || "";
        const finalTarget = target || postcodeTargetRef.current || "orderer";

        if (finalTarget === "orderer") {
            setOrdererZip(zonecode);
            setOrdererAddr1(addr);
            setOrdererAddr2("");
        } else if (finalTarget === "receiver") {
            setRecvZip(zonecode);
            setRecvAddr1(addr);
            setRecvAddr2("");
        }
    };

    const openPostcodeLayer = async (target) => {
        const isApp = typeof window !== "undefined" && !!window.ReactNativeWebView;

        if (!isApp) {
            try {
                await loadPostcodeScript();
                new window.daum.Postcode({
                    oncomplete: (data) => handlePostcodeComplete(data, target),
                }).open();
            } catch (e) {
                console.error(e);
                alert("주소 검색을 불러오지 못했어요. 잠시 후 다시 시도해주세요.");
            }
            return;
        }

        postcodeTargetRef.current = target;
        setPostcodeVisible(true);
    };

    const closePostcodeLayer = () => setPostcodeVisible(false);

    useEffect(() => {
        const isApp = typeof window !== "undefined" && !!window.ReactNativeWebView;
        if (!isApp) return;
        if (!postcodeVisible) return;

        let cancelled = false;

        (async () => {
            try {
                await loadPostcodeScript();
                if (cancelled) return;
                if (!postcodeContainerRef.current) return;

                const target = postcodeTargetRef.current || "orderer";
                const pc = new window.daum.Postcode({
                    oncomplete: (data) => {
                        handlePostcodeComplete(data, target);
                        setPostcodeVisible(false);
                    },
                    width: "100%",
                    height: "100%",
                });

                pc.embed(postcodeContainerRef.current);
            } catch (e) {
                console.error("[StoreDetailPage] postcode embed error", e);
                if (!cancelled) {
                    alert("주소 검색을 불러오지 못했어요. 잠시 후 다시 시도해주세요.");
                    setPostcodeVisible(false);
                }
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [postcodeVisible]);

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const p = await fetchProductById(id);
                if (!alive) return;
                setProd(p);
            } catch (e) {
                console.error("[StoreDetailPage] load error:", e);
                if (!alive) return;
                setProd(null);
            }
        })();
        return () => {
            alive = false;
        };
    }, [id]);

    useEffect(() => {
        let cancelled = false;

        async function run() {
            if (!phoneE164) {
                setProfileLoading(false);
                return;
            }
            try {
                const profile = await getDefaultOrderProfile(phoneE164);
                if (cancelled) return;
                if (profile && profile.orderer) {
                    const o = profile.orderer;
                    const r = profile.receiver || profile.orderer;

                    setOrdererName(o.name || "");
                    setOrdererPhone(o.phone || "");
                    setOrdererEmail(o.email || "");
                    setOrdererZip(o.zip || "");
                    setOrdererAddr1(o.addr1 || "");
                    setOrdererAddr2(o.addr2 || "");

                    setRecvName(r.name || "");
                    setRecvPhone(r.phone || "");
                    setRecvZip(r.zip || "");
                    setRecvAddr1(r.addr1 || "");
                    setRecvAddr2(r.addr2 || "");

                    setSameAsOrderer(
                        r.name === o.name &&
                        r.phone === o.phone &&
                        r.addr1 === o.addr1 &&
                        r.addr2 === o.addr2 &&
                        r.zip === o.zip
                    );
                    setHasDefaultProfile(true);
                } else {
                    setHasDefaultProfile(false);
                }
            } catch (e) {
                console.error("[StoreDetailPage] load default profile error", e);
            } finally {
                if (!cancelled) setProfileLoading(false);
            }
        }

        run();
        return () => {
            cancelled = true;
        };
    }, [phoneE164]);

    // ✅ thumb을 배열(string[]) 또는 단일 string 모두 지원
    const images = useMemo(() => {
        const t = prod?.thumb;

        if (Array.isArray(t)) return t.filter(Boolean);
        if (typeof t === "string" && t) return [t];
        if (t && typeof t === "object" && typeof t.url === "string") return [t.url];

        return [];
    }, [prod]);

    useEffect(() => {
        if (idx >= images.length) setIdx(0);
    }, [images.length, idx]);

    const primaryThumb = useMemo(() => {
        if (!images.length) return "";
        return images[0] || "";
    }, [images]);

    const handleHeroTouchStart = (e) => {
        if (!images.length) return;
        touchStartXRef.current = e.touches[0].clientX;
        touchDeltaXRef.current = 0;
        setHeroAnim(false);
    };

    const handleHeroTouchMove = (e) => {
        if (touchStartXRef.current == null || !images.length) return;
        touchDeltaXRef.current = e.touches[0].clientX - touchStartXRef.current;
    };

    const handleHeroTouchEnd = (e) => {
        if (!images.length) return;
        const deltaX = touchDeltaXRef.current || 0;
        const w = e.currentTarget.clientWidth || 1;
        const threshold = Math.min(60, w * 0.12);

        let next = idx;
        if (deltaX <= -threshold && idx < images.length - 1) next = idx + 1;
        else if (deltaX >= threshold && idx > 0) next = idx - 1;

        setHeroAnim(true);
        setIdx(next);
        touchStartXRef.current = null;
        touchDeltaXRef.current = 0;
    };

    // 상품별 배송 정책 계산
    const shippingRule = prod?.shippingRule || {};
    const legacyShippingFee = typeof prod?.shippingFee === "number" ? prod.shippingFee : 0;
    const freeThreshold = Number(shippingRule.freeThreshold ?? 0);
    const baseFee = Number(shippingRule.baseFee ?? legacyShippingFee);

    const optionExtraTotal = useMemo(() => {
        if (!prod?.requiredOptions) return 0;
        return (prod.requiredOptions || []).reduce((sum, op, gi) => {
            const selIdx = selectedOptions[gi];
            if (selIdx === undefined || selIdx === null) return sum;
            const items = op.items || [];
            const item = items[selIdx];
            if (!item) return sum;
            const extra = Number(item.extraPrice || 0);
            return sum + extra;
        }, 0);
    }, [prod, selectedOptions]);

    const unitBase = Number(prod?.priceKRW || 0);
    const unitTotal = unitBase + optionExtraTotal;

    const goodsSubtotal = unitTotal * qty;

    const shippingFee =
        freeThreshold > 0 ? (goodsSubtotal >= freeThreshold ? 0 : baseFee) : baseFee;

    const shippingLabel = (() => {
        if (freeThreshold <= 0 && baseFee <= 0) return "배송비 없음";
        if (freeThreshold <= 0 && baseFee > 0) return `배송비 ${KRW(baseFee)}`;
        if (freeThreshold > 0 && baseFee <= 0) return `${KRW(freeThreshold)} 이상 무료 (배송비 0원)`;
        return `${KRW(freeThreshold)} 미만 ${KRW(baseFee)}, 이상 무료`;
    })();

    const totalPrice = goodsSubtotal + shippingFee;

    const payablePrice = useMemo(() => {
        const u = Math.max(0, safeInt(usePoints));
        return Math.max(0, totalPrice - u);
    }, [totalPrice, usePoints]);

    const handleToggleSameAsOrderer = (e) => {
        const next = e.target.checked;
        setSameAsOrderer(next);
        if (next) {
            setRecvName(ordererName);
            setRecvPhone(ordererPhone);
            setRecvAddr1(ordererAddr1);
            setRecvAddr2(ordererAddr2);
            setRecvZip(ordererZip);
        }
    };

    const handleSelectOption = (groupIndex, itemIndex) => {
        setSelectedOptions((prev) => ({
            ...prev,
            [groupIndex]: itemIndex,
        }));
    };

    const openOrder = () => {
        if (!prod) return;

        const requiredOptions = prod.requiredOptions || [];
        if (requiredOptions.length) {
            for (let i = 0; i < requiredOptions.length; i++) {
                const op = requiredOptions[i];
                const items = op.items || [];
                if (items.length && (selectedOptions[i] === undefined || selectedOptions[i] === null)) {
                    alert(`옵션을 선택해 주세요.`);
                    return;
                }
            }
        }

        setOrderOpen(true);
    };

    const closeOrder = () => setOrderOpen(false);

    /* ======================================================
       ✅ 포인트: members에서 phoneE164로 memberDocId 찾기
       ====================================================== */
    useEffect(() => {
        let cancelled = false;

        async function run() {
            if (!phoneE164) {
                setMemberDocId("");
                return;
            }
            try {
                const col = collection(db, "members");
                const q = query(col, where("phoneE164", "==", phoneE164), limit(1));
                const snap = await getDocs(q);
                if (cancelled) return;

                if (snap.empty) {
                    setMemberDocId("");
                    return;
                }
                setMemberDocId(snap.docs[0].id);
            } catch (e) {
                console.error("[StoreDetailPage] resolve memberDocId error", e);
                if (!cancelled) setMemberDocId("");
            }
        }

        run();
        return () => {
            cancelled = true;
        };
    }, [phoneE164]);

    /* ======================================================
       ✅ 바텀시트 열릴 때 포인트 잔액 조회 (memberDocId 기반)
       ====================================================== */
    useEffect(() => {
        let cancelled = false;

        async function run() {
            if (!orderOpen) return;

            setUsePoints(0);

            if (!phoneE164) {
                setPointsBalance(0);
                return;
            }
            if (!memberDocId) {
                setPointsBalance(0);
                return;
            }

            try {
                setPointsLoading(true);
                const res = await fetchMemberPointsBalance({ memberId: memberDocId });
                if (cancelled) return;
                setPointsBalance(safeInt(res?.balance));
            } catch (e) {
                console.error("[StoreDetailPage] fetch points balance error", e);
                if (cancelled) return;
                setPointsBalance(0);
            } finally {
                if (!cancelled) setPointsLoading(false);
            }
        }

        run();
        return () => {
            cancelled = true;
        };
    }, [orderOpen, phoneE164, memberDocId]);

    const handleClearDefaultProfile = async () => {
        if (!phoneE164) return;
        const ok = window.confirm("저장된 기본 배송지를 삭제할까요?");
        if (!ok) return;

        try {
            await clearDefaultOrderProfile(phoneE164);
            setHasDefaultProfile(false);
            setOrdererName("");
            setOrdererPhone("");
            setOrdererEmail("");
            setOrdererZip("");
            setOrdererAddr1("");
            setOrdererAddr2("");
            setRecvName("");
            setRecvPhone("");
            setRecvZip("");
            setRecvAddr1("");
            setRecvAddr2("");
            setSameAsOrderer(false);
            alert("기본 배송지가 삭제되었습니다.");
        } catch (e) {
            console.error("[StoreDetailPage] clear default profile error", e);
            alert("기본 배송지 삭제 중 오류가 발생했습니다.");
        }
    };

    const bankDisplayText = useMemo(() => {
        return typeof prod?.bankAccount === "string" ? prod.bankAccount.trim() : "";
    }, [prod]);

    const buildOptionSelections = () => {
        const requiredOptions = prod?.requiredOptions || [];
        return requiredOptions
            .map((op, gi) => {
                const items = op.items || [];
                const selIdx = selectedOptions[gi];
                if (selIdx === undefined || selIdx === null) return null;
                const item = items[selIdx];
                if (!item) return null;
                return {
                    groupName: op.name,
                    value: item.label,
                    extraPrice: Number(item.extraPrice || 0),
                };
            })
            .filter(Boolean);
    };

    const validatePoints = () => {
        const u = safeInt(usePoints);
        if (u < 0) return { ok: false, msg: "포인트는 0 이상이어야 합니다." };
        if (u > safeInt(pointsBalance)) return { ok: false, msg: "보유 포인트를 초과할 수 없습니다." };
        if (u > totalPrice) return { ok: false, msg: "결제 예정 금액을 초과할 수 없습니다." };
        return { ok: true, msg: "" };
    };

    const handleSubmitOrder = async () => {
        if (!prod) return;

        if (!phoneE164) {
            alert("로그인 정보가 없습니다. 홈에서 다시 접속해주세요.");
            return;
        }

        if (!memberDocId) {
            alert("회원 정보를 찾을 수 없습니다. 다시 로그인 후 시도해주세요.");
            return;
        }

        const requiredOptions = prod.requiredOptions || [];
        for (let i = 0; i < requiredOptions.length; i++) {
            const op = requiredOptions[i];
            const items = op.items || [];
            if (items.length && (selectedOptions[i] === undefined || selectedOptions[i] === null)) {
                alert(`옵션을 선택해 주세요.`);
                return;
            }
        }

        if (qty < 1) {
            alert("수량은 1개 이상이어야 합니다.");
            return;
        }

        if (!ordererName.trim() || !ordererPhone.trim()) {
            alert("주문자 이름과 휴대폰 번호를 입력해주세요.");
            return;
        }
        if (!ordererZip.trim() || !ordererAddr1.trim() || !ordererAddr2.trim()) {
            alert("주문자 주소를 모두 입력해주세요.");
            return;
        }
        if (!recvName.trim() || !recvPhone.trim()) {
            alert("받는 분 이름과 휴대폰 번호를 입력해주세요.");
            return;
        }
        if (!recvZip.trim() || !recvAddr1.trim() || !recvAddr2.trim()) {
            alert("배송 주소를 모두 입력해주세요.");
            return;
        }

        const pv = validatePoints();
        if (!pv.ok) {
            alert(pv.msg);
            return;
        }

        const optionSelections = buildOptionSelections();

        const ordererPayload = {
            name: ordererName.trim(),
            phone: ordererPhone.trim(),
            email: ordererEmail.trim(),
            zip: ordererZip.trim(),
            addr1: ordererAddr1.trim(),
            addr2: ordererAddr2.trim(),
        };

        const receiverPayload = {
            name: recvName.trim(),
            phone: recvPhone.trim(),
            zip: recvZip.trim(),
            addr1: recvAddr1.trim(),
            addr2: recvAddr2.trim(),
            memo: recvMemo.trim(),
        };

        const itemPayload = {
            productId: prod.id || id,
            productTitle: prod.title || "",
            thumb: primaryThumb,
            unitPrice: unitBase,
            qty,
            optionSelections,
            shippingFeePerItem: shippingFee,
        };

        const usedPoints = safeInt(usePoints);

        try {
            const created = await createStoreOrder({
                ownerPhoneE164: phoneE164,
                items: [itemPayload],
                orderer: ordererPayload,
                receiver: receiverPayload,
                channel: "store",
                pricing: {
                    goodsSubtotal,
                    shippingFee,
                    totalPrice,
                    pointsUsed: usedPoints,
                    payablePrice,
                    currency: "KRW",
                },
                payment: {
                    method: "bank_transfer",
                    bankAccount: bankDisplayText || "",
                },
            });

            const orderId = safeStr(created?.orderId || created?.id);
            if (!orderId) {
                throw new Error("주문 생성 응답에 orderId가 없습니다.");
            }

            // ✅ 포인트 차감 (Franchise와 동일)
            if (usedPoints > 0) {
                try {
                    const orderTitleSnapshot = safeStr(prod?.title) || "상품";
                    await applyPointsChange({
                        memberId: memberDocId,
                        phoneE164,
                        delta: -usedPoints,
                        reasonType: "ORDER_USE",
                        reason: `주문 사용 (${orderId})`,
                        actorRole: "user",
                        actorId: phoneE164,
                        source: "order",
                        type: "deduct",
                        orderId,
                        orderTitleSnapshot
                    });

                    setPointsBalance((b) => Math.max(0, safeInt(b) - usedPoints));
                } catch (pe) {
                    console.error("[StoreDetailPage] points deduct failed", pe);

                    // ✅ 주문 pricing 롤백
                    try {
                        await updateStoreOrder(orderId, {
                            pricing: {
                                goodsSubtotal,
                                shippingFee,
                                totalPrice,
                                pointsUsed: 0,
                                payablePrice: totalPrice,
                                currency: "KRW",
                            },
                        });
                    } catch (re) {
                        console.error("[StoreDetailPage] order pricing rollback failed", re);
                    }

                    throw new Error(pe?.message || "포인트 차감에 실패했습니다. 다시 시도해주세요.");
                }
            }

            if (saveAsDefault) {
                try {
                    await saveDefaultOrderProfile(phoneE164, {
                        orderer: ordererPayload,
                        receiver: receiverPayload,
                    });
                    setHasDefaultProfile(true);
                } catch (e) {
                    console.error("[StoreDetailPage] save default profile error", e);
                }
            }

            closeOrder();

            const goList = window.confirm(
                "주문이 접수되었어요.\n지금은 무통장 입금으로만 주문 가능합니다.\n\n입금 후 '주문 내역'에서 상태를 확인해 주세요.\n\n스토어 화면으로 이동할까요?"
            );
            if (goList) nav("/store");
        } catch (e) {
            console.error(e);
            alert(e?.message || "주문 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
        }
    };

    const handleAddToCart = async () => {
        if (!prod) return;

        if (!phoneE164) {
            alert("로그인 정보가 없습니다. 홈에서 다시 접속해주세요.");
            return;
        }

        const requiredOptions = prod.requiredOptions || [];
        for (let i = 0; i < requiredOptions.length; i++) {
            const op = requiredOptions[i];
            const items = op.items || [];
            if (items.length && (selectedOptions[i] === undefined || selectedOptions[i] === null)) {
                alert(`옵션을 선택해 주세요.`);
                return;
            }
        }

        if (qty < 1) {
            alert("수량은 1개 이상이어야 합니다.");
            return;
        }

        const optionSelections = buildOptionSelections();

        const payload = {
            ownerPhoneE164: phoneE164,
            productId: prod.id || id,
            productTitleSnapshot: prod.title || "",
            thumb: primaryThumb,
            unitPrice: unitBase,
            qty,
            optionSelections,
        };

        try {
            await addStoreCartItem(payload);
            nav("/store/cart");
        } catch (e) {
            console.error("[StoreDetailPage] addStoreCartItem error", e);
            alert("장바구니 담기 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
        }
    };

    if (!prod) {
        return (
            <Wrap>
                <Sheet>
                    <Body>
                        <div style={{ fontSize: 14, color: "#64748b" }}>불러오는 중…</div>
                    </Body>
                </Sheet>
            </Wrap>
        );
    }

    const maxUsablePoints = Math.min(totalPrice, safeInt(pointsBalance));

    return (
        <Wrap>
            <Sheet>
                <PageTopBar variant="back" label="뒤로가기" />

                <Body>
                    {images.length > 0 && (
                        <>
                            <Hero onTouchStart={handleHeroTouchStart} onTouchMove={handleHeroTouchMove} onTouchEnd={handleHeroTouchEnd}>
                                <HeroTrack $index={idx} $anim={heroAnim}>
                                    {images.map((src, i) => (
                                        <HeroSlide key={i}>
                                            <img src={src} alt="" />
                                        </HeroSlide>
                                    ))}
                                </HeroTrack>
                            </Hero>
                            {images.length > 1 && (
                                <Dots>
                                    {images.map((_, i) => (
                                        <Dot key={i} $on={i === idx} onClick={() => setIdx(i)} />
                                    ))}
                                </Dots>
                            )}
                        </>
                    )}

                    <Label>기본 정보</Label>
                    <Divider />
                    <Title>{prod.title}</Title>
                    <Price>{KRW(prod.priceKRW)}</Price>
                    {prod.shortDesc ? <Subtle>{prod.shortDesc}</Subtle> : null}
                    <Subtle>{shippingLabel}</Subtle>

                    {prod.requiredOptions?.length ? (
                        <>
                            <Label>옵션</Label>
                            <Divider />
                            {prod.requiredOptions.map((op, i) => (
                                <div key={i} style={{ marginBottom: 10 }}>
                                    <Subtle style={{ marginBottom: 6, fontWeight: 700, color: "#0f172a" }}>
                                        {op.name}
                                    </Subtle>
                                    <OptionChipsRow>
                                        {(op.items || []).map((item, ii) => (
                                            <OptionChip
                                                key={ii}
                                                type="button"
                                                $active={selectedOptions[i] === ii}
                                                onClick={() => handleSelectOption(i, ii)}
                                            >
                                                {item.label}
                                                {item.extraPrice ? ` (+${KRW(item.extraPrice)})` : ""}
                                            </OptionChip>
                                        ))}
                                    </OptionChipsRow>
                                    <div style={{ marginTop: 2, fontSize: 11, color: "#9ca3af" }}>
                                        필수 옵션입니다. 하나를 선택해 주세요.
                                    </div>
                                </div>
                            ))}
                        </>
                    ) : null}

                    {prod.shippingGuide ? (
                        <>
                            <Label>배송 안내</Label>
                            <Divider />
                            <Text>{prod.shippingGuide}</Text>
                        </>
                    ) : null}

                    {prod.returnGuide ? (
                        <>
                            <Label>교환·반품 안내</Label>
                            <Divider />
                            <Text>{prod.returnGuide}</Text>
                        </>
                    ) : null}

                    {(prod.detailImages?.length || 0) > 0 && (
                        <>
                            <Label>상세 설명</Label>
                            <Divider />
                            <DetailImages>
                                {(prod.detailImages || []).map((u, i) => (
                                    <img key={i} src={u} alt="" />
                                ))}
                            </DetailImages>
                        </>
                    )}

                    {bankDisplayText ? (
                        <>
                            <Label>입금 계좌</Label>
                            <Divider />
                            <BankBox>
                                <div className="row">
                                    <div style={{ fontWeight: 400, color: "#0f172a" }}>{bankDisplayText}</div>
                                    <button
                                        className="copy"
                                        type="button"
                                        onClick={() => {
                                            navigator.clipboard?.writeText(bankDisplayText).then(() => {
                                                alert("계좌번호를 복사했어요.");
                                            });
                                        }}
                                    >
                                        계좌 복사
                                    </button>
                                </div>
                            </BankBox>
                        </>
                    ) : null}

                    {!orderOpen && (
                        <FixedOrderBarOuter>
                            <FixedOrderBarInner>
                                <FixedOrderSummary>
                                    <span className="label">상품 가격 (옵션 포함)</span>
                                    <span className="price">{KRW(unitTotal)}</span>
                                </FixedOrderSummary>

                                <div style={{ display: "flex", flex: 1, justifyContent: "flex-end", gap: 8 }}>
                                    <FixedCartButton type="button" onClick={handleAddToCart}>
                                        장바구니 담기
                                    </FixedCartButton>
                                    <FixedOrderButton type="button" onClick={openOrder}>
                                        주문하기
                                    </FixedOrderButton>
                                </div>
                            </FixedOrderBarInner>
                        </FixedOrderBarOuter>
                    )}
                </Body>

                {orderOpen && (
                    <OrderOverlay onClick={closeOrder}>
                        <OrderSheet onClick={(e) => e.stopPropagation()}>
                            <SheetHandle />
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 4 }}>
                                <SheetTitle>주문 정보 입력</SheetTitle>
                                <PostcodeCloseButton type="button" onClick={closeOrder}>
                                    닫기
                                </PostcodeCloseButton>
                            </div>

                            <OrderContent>
                                <SheetSection>
                                    <SectionHeader>상품 / 옵션 / 수량</SectionHeader>
                                    <div style={{ fontSize: 13, color: "#0f172a" }}>{prod.title}</div>
                                    <SheetSummaryRow>
                                        <span style={{ fontSize: 12, color: "#6b7280" }}>기본가</span>
                                        <span style={{ fontSize: 13, fontWeight: 600 }}>{KRW(unitBase)}</span>
                                    </SheetSummaryRow>

                                    {prod.requiredOptions?.length ? (
                                        <div style={{ marginTop: 6 }}>
                                            <FieldLabel>선택된 옵션</FieldLabel>
                                            <div style={{ fontSize: 12, color: "#374151", lineHeight: 1.5 }}>
                                                {prod.requiredOptions.map((op, gi) => {
                                                    const selIdx = selectedOptions[gi];
                                                    const items = op.items || [];
                                                    const item = selIdx != null ? items[selIdx] : null;

                                                    if (!item) {
                                                        return (
                                                            <div key={gi}>
                                                                {op.name}: <span style={{ color: "#ef4444" }}>미선택</span>
                                                            </div>
                                                        );
                                                    }

                                                    return (
                                                        <div key={gi}>
                                                            {op.name}: {item.label}
                                                            {item.extraPrice ? ` (+${KRW(item.extraPrice)})` : ""}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            <div style={{ marginTop: 2, fontSize: 11, color: "#9ca3af" }}>
                                                옵션을 변경하려면 이 창을 닫고 위쪽 옵션 영역에서 다시 선택해 주세요.
                                            </div>
                                        </div>
                                    ) : null}

                                    <FieldRow>
                                        <FieldLabel>수량</FieldLabel>
                                        <QtyRow>
                                            <QtyButton type="button" onClick={() => setQty((q) => Math.max(1, q - 1))}>
                                                -
                                            </QtyButton>
                                            <QtyValue>{qty}</QtyValue>
                                            <QtyButton type="button" onClick={() => setQty((q) => q + 1)}>
                                                +
                                            </QtyButton>
                                        </QtyRow>
                                    </FieldRow>
                                </SheetSection>

                                <SheetSection>
                                    <SectionHeader>주문자 정보</SectionHeader>

                                    <FieldRow>
                                        <FieldLabel>이름</FieldLabel>
                                        <Input value={ordererName} onChange={(e) => setOrdererName(e.target.value)} placeholder="주문자 이름" />
                                    </FieldRow>

                                    <FieldRow>
                                        <FieldLabel>휴대폰 번호</FieldLabel>
                                        <Input value={ordererPhone} onChange={(e) => setOrdererPhone(e.target.value)} placeholder="예: 010-0000-0000" />
                                    </FieldRow>

                                    <FieldRow>
                                        <FieldLabel>주소</FieldLabel>
                                        <AddressRow>
                                            <Input value={ordererAddr1} onChange={(e) => setOrdererAddr1(e.target.value)} placeholder="기본 주소" />
                                            <AddressSearchButton type="button" onClick={() => openPostcodeLayer("orderer")}>
                                                주소 찾기
                                            </AddressSearchButton>
                                        </AddressRow>
                                        <Input value={ordererAddr2} onChange={(e) => setOrdererAddr2(e.target.value)} placeholder="상세 주소" />
                                    </FieldRow>

                                    <FieldRow>
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, marginTop: 4 }}>
                                            <label style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 11, color: "#6b7280", cursor: "pointer" }}>
                                                <input
                                                    type="checkbox"
                                                    checked={saveAsDefault}
                                                    disabled={profileLoading || !phoneE164}
                                                    onChange={(e) => setSaveAsDefault(e.target.checked)}
                                                    style={{ width: 14, height: 14 }}
                                                />
                                                <span>이 정보를 기본 배송지로 저장</span>
                                            </label>
                                            {hasDefaultProfile && (
                                                <button
                                                    type="button"
                                                    onClick={handleClearDefaultProfile}
                                                    style={{
                                                        fontSize: 11,
                                                        padding: "4px 8px",
                                                        borderRadius: 999,
                                                        border: "1px solid #e5e7eb",
                                                        background: "#fff",
                                                        cursor: "pointer",
                                                        color: "#6b7280",
                                                    }}
                                                >
                                                    기본정보 삭제
                                                </button>
                                            )}
                                        </div>
                                        {saveAsDefault && (
                                            <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 2 }}>
                                                다음 주문부터 자동으로 이 정보가 채워집니다.
                                            </div>
                                        )}
                                    </FieldRow>
                                </SheetSection>

                                <SheetSection>
                                    <SectionHeaderRow>
                                        <SectionHeader>배송 정보</SectionHeader>
                                        <label style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 11, color: "#6b7280", cursor: "pointer" }}>
                                            <input type="checkbox" checked={sameAsOrderer} onChange={handleToggleSameAsOrderer} style={{ width: 14, height: 14 }} />
                                            <span>주문자 정보와 동일</span>
                                        </label>
                                    </SectionHeaderRow>

                                    <FieldRow>
                                        <FieldLabel>받는 분 이름</FieldLabel>
                                        <Input value={recvName} onChange={(e) => setRecvName(e.target.value)} placeholder="수령인 이름" />
                                    </FieldRow>

                                    <FieldRow>
                                        <FieldLabel>휴대폰 번호</FieldLabel>
                                        <Input value={recvPhone} onChange={(e) => setRecvPhone(e.target.value)} placeholder="예: 010-0000-0000" />
                                    </FieldRow>

                                    <FieldRow>
                                        <FieldLabel>배송 주소</FieldLabel>
                                        <AddressRow>
                                            <Input value={recvAddr1} onChange={(e) => setRecvAddr1(e.target.value)} placeholder="기본 주소" />
                                            <AddressSearchButton type="button" onClick={() => openPostcodeLayer("receiver")}>
                                                주소 찾기
                                            </AddressSearchButton>
                                        </AddressRow>
                                        <Input value={recvAddr2} onChange={(e) => setRecvAddr2(e.target.value)} placeholder="상세 주소" />
                                    </FieldRow>

                                    <FieldRow>
                                        <FieldLabel>배송 요청사항 (선택)</FieldLabel>
                                        <Textarea value={recvMemo} onChange={(e) => setRecvMemo(e.target.value)} placeholder="예) 부재 시 경비실에 맡겨주세요." />
                                    </FieldRow>
                                </SheetSection>

                                {/* ✅ 포인트 사용 (Franchise UI/로직 동일) */}
                                <SheetSection>
                                    <SectionHeader>포인트 사용</SectionHeader>

                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                                        <div style={{ fontSize: 12, color: "#6b7280" }}>
                                            보유 포인트:{" "}
                                            <span style={{ color: "#0f172a", fontWeight: 700 }}>
                                                {pointsLoading ? "조회중…" : `${safeInt(pointsBalance).toLocaleString("ko-KR")}P`}
                                            </span>
                                        </div>

                                        <div style={{ display: "flex", gap: 6 }}>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    const max = Math.min(totalPrice, safeInt(pointsBalance));
                                                    setUsePoints(max);
                                                }}
                                                style={{
                                                    fontSize: 11,
                                                    padding: "4px 8px",
                                                    borderRadius: 999,
                                                    border: "1px solid #e5e7eb",
                                                    background: "#fff",
                                                    cursor: "pointer",
                                                    color: "#6b7280",
                                                }}
                                            >
                                                최대 사용
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => setUsePoints(0)}
                                                style={{
                                                    fontSize: 11,
                                                    padding: "4px 8px",
                                                    borderRadius: 999,
                                                    border: "1px solid #e5e7eb",
                                                    background: "#fff",
                                                    cursor: "pointer",
                                                    color: "#6b7280",
                                                }}
                                            >
                                                사용 안함
                                            </button>
                                        </div>
                                    </div>

                                    <FieldRow>
                                        <FieldLabel>사용할 포인트</FieldLabel>
                                        <Input
                                            inputMode="numeric"
                                            value={String(usePoints ?? 0)}
                                            onChange={(e) => {
                                                const v = safeInt(String(e.target.value || "").replace(/[^\d]/g, ""));
                                                const max = Math.min(totalPrice, safeInt(pointsBalance));
                                                setUsePoints(Math.min(v, max));
                                            }}
                                            placeholder="0"
                                        />
                                        <div style={{ fontSize: 11, color: "#94a3b8" }}>
                                            최대 {maxUsablePoints.toLocaleString("ko-KR")}P 까지 사용 가능합니다.
                                        </div>
                                    </FieldRow>
                                </SheetSection>

                                {bankDisplayText ? (
                                    <SheetSection>
                                        <SectionHeader>입금 계좌 안내</SectionHeader>
                                        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginTop: 4 }}>
                                            <span style={{ fontSize: 13, color: "#0f172a", fontWeight: 600 }}>{bankDisplayText}</span>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    navigator.clipboard?.writeText(bankDisplayText).then(() => alert("계좌번호를 복사했어요."));
                                                }}
                                                style={{
                                                    fontSize: 11,
                                                    padding: "4px 8px",
                                                    borderRadius: 999,
                                                    border: "1px solid #e5e7eb",
                                                    background: "#fff",
                                                    cursor: "pointer",
                                                    color: "#6b7280",
                                                }}
                                            >
                                                계좌 복사
                                            </button>
                                        </div>
                                    </SheetSection>
                                ) : null}
                            </OrderContent>

                            <SheetBottom>
                                <SheetSummaryRow>
                                    <span>상품가 + 옵션</span>
                                    <span>
                                        {KRW(unitTotal)} × {qty}
                                    </span>
                                </SheetSummaryRow>
                                <SheetSummaryRow>
                                    <span>배송비</span>
                                    <span>{KRW(shippingFee)}</span>
                                </SheetSummaryRow>
                                <SheetSummaryRow>
                                    <span>포인트 사용</span>
                                    <span>- {safeInt(Math.min(totalPrice, Math.max(0, safeInt(usePoints)))).toLocaleString("ko-KR")}P</span>
                                </SheetSummaryRow>
                                <SheetSummaryRow>
                                    <SheetTotal>총 결제 예정 금액</SheetTotal>
                                    <SheetTotal>{KRW(payablePrice)}</SheetTotal>
                                </SheetSummaryRow>

                                <div style={{ fontSize: 11, color: "#94a3b8" }}>
                                    지금은 무통장 입금으로만 주문이 가능합니다.
                                </div>

                                <SheetButtons>
                                    <CartLinkButton
                                        type="button"
                                        onClick={async () => {
                                            await handleAddToCart();
                                            closeOrder();
                                        }}
                                    >
                                        장바구니 담기
                                    </CartLinkButton>

                                    <SubmitBtn type="button" onClick={handleSubmitOrder}>
                                        주문 신청하기
                                    </SubmitBtn>
                                </SheetButtons>
                            </SheetBottom>
                        </OrderSheet>
                    </OrderOverlay>
                )}

                {postcodeVisible && (
                    <PostcodeOverlay onClick={closePostcodeLayer}>
                        <PostcodePanel onClick={(e) => e.stopPropagation()}>
                            <PostcodeHeader>
                                <PostcodeTitle>주소 검색</PostcodeTitle>
                                <PostcodeCloseButton type="button" onClick={closePostcodeLayer}>
                                    닫기
                                </PostcodeCloseButton>
                            </PostcodeHeader>
                            <PostcodeBody>
                                <div ref={postcodeContainerRef} style={{ width: "100%", height: "100%" }} />
                            </PostcodeBody>
                        </PostcodePanel>
                    </PostcodeOverlay>
                )}
            </Sheet>
        </Wrap>
    );
}
